import React from 'react';

import { useSelector } from 'react-redux';
import { MODALCOLLABORATIONSTEPCOUNT } from 'src/components/ModalCollaborationDeploy/ModalCollaborationDeployConstants';
import { selectCollaborationStep } from 'src/redux/application/application.selectors';

import s from './CollaborationSteps.module.scss';

export const CollaborationSteps: React.FC = ({}) => {
  const step = useSelector(selectCollaborationStep);

  return (
    <p className={s.stepText}>
      {step + 1} of {MODALCOLLABORATIONSTEPCOUNT}
    </p>
  );
};
